import { createFeatureSelector, createSelector } from '@ngrx/store'
import { StoreKeysEnum } from '../../../../store/store-keys'
import { IBarterListState } from './barter-list.reducer'
import cloneDeep from 'lodash/cloneDeep'

export const selectBarterListFeature = createFeatureSelector<Readonly<IBarterListState>>(StoreKeysEnum.BarterListFeature)

export const selectBarterListFilterCriteria = createSelector(
    selectBarterListFeature,
    feature => (feature.filterCriteria),
)
export const selectBarterListItemCollection = createSelector(
    selectBarterListFeature,
    feature => cloneDeep(feature.itemCollection),
)
export const selectBarterListFilter = createSelector(
    selectBarterListFeature,
    feature => (feature.filter),
)
export const selectBarterListState = createSelector(
    selectBarterListFilterCriteria,
    selectBarterListItemCollection,
    selectBarterListFilter,
    (filterCriteria, itemCollection, filter) => ({
        filterCriteria, itemCollection, filter,
    }),
)